import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i3 from 'base-organize-documents-library';
import { BaseOrganizeDocumentsLibraryService } from 'base-organize-documents-library';
import * as i1 from 'ngx-toastr';
import * as i2 from '@ngrx/store';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/forms';
import * as i7 from 'primeng/button';
import * as i8 from 'primeng/tree';
import * as i9 from 'primeng/api';
import * as i10 from '@angular/common';
import * as i11 from 'primeng/confirmdialog';
import * as i12 from 'primeng/inplace';
import * as i13 from 'primeng/inputtext';
import * as i14 from 'primeng/tooltip';
import * as i15 from '@angular/material/icon';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class OrganizeDocumentsLibraryService {
    constructor() { }
}
OrganizeDocumentsLibraryService.ɵfac = function OrganizeDocumentsLibraryService_Factory(t) { return new (t || OrganizeDocumentsLibraryService)(); };
OrganizeDocumentsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: OrganizeDocumentsLibraryService, factory: OrganizeDocumentsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganizeDocumentsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["organizeDocumentsForm"];
function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r3.data.titleSheetName, " ");
} }
const _c1 = function () { return { "min-height": "33px" }; };
function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-inplace", 22, 23);
    i0.ɵɵtemplate(2, OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_2_ng_template_2_Template, 3, 1, "ng-template", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(2, _c1));
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(node_r3.data.categoryName);
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 28);
    i0.ɵɵlistener("ngModelChange", function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const node_r3 = i0.ɵɵnextContext(2).$implicit; return node_r3.data.categoryName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "button", 29);
    i0.ɵɵlistener("click", function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_3_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(3); return ctx_r18.renameCustomTitleSheet($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngModel", node_r3.data.categoryName);
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-inplace", 22, 26);
    i0.ɵɵtemplate(2, OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_2_Template, 3, 1, "ng-template", 24);
    i0.ɵɵtemplate(3, OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_ng_template_3_Template, 2, 1, "ng-template", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(2, _c1));
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "i", 33);
    i0.ɵɵelement(2, "i", 34);
    i0.ɵɵelementEnd();
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, OrganizeDocumentsLibraryComponent_ng_template_10_div_4_div_1_Template, 3, 0, "div", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r3.class != "custom");
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵelementStart(3, "small", 36);
    i0.ɵɵtext(4, "Drag & Drop related documents to this title sheet.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OrganizeDocumentsLibraryComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_2_Template, 3, 3, "p-inplace", 14);
    i0.ɵɵtemplate(3, OrganizeDocumentsLibraryComponent_ng_template_10_p_inplace_3_Template, 4, 3, "p-inplace", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, OrganizeDocumentsLibraryComponent_ng_template_10_div_4_Template, 2, 1, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵelementStart(6, "div", 17);
    i0.ɵɵelementStart(7, "tr", 18);
    i0.ɵɵelementStart(8, "th", 19);
    i0.ɵɵtext(9, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 19);
    i0.ɵɵtext(11, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelementStart(13, "span", 20);
    i0.ɵɵtext(14, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, OrganizeDocumentsLibraryComponent_ng_template_10_div_15_Template, 5, 0, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r3.class != "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r3.class == "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.disabledControls);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", node_r3.class == "custom" && node_r3.children.length == 0);
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 47);
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "(System Generated)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "(Manual Uploaded)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const singleDoc_r24 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", singleDoc_r24.uploadedFileName, " ");
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const singleDoc_r24 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", singleDoc_r24.fileName, " ");
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelement(1, "i", 33);
    i0.ɵɵelement(2, "i", 50);
    i0.ɵɵelementEnd();
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_div_1_Template, 1, 0, "div", 39);
    i0.ɵɵelementStart(2, "tr", 40);
    i0.ɵɵelementStart(3, "td", 19);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_5_Template, 3, 0, "span", 41);
    i0.ɵɵtemplate(6, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_6_Template, 3, 0, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 19);
    i0.ɵɵtemplate(8, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_8_Template, 2, 1, "span", 42);
    i0.ɵɵtemplate(9, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_span_9_Template, 2, 1, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 43);
    i0.ɵɵelementStart(12, "button", 44);
    i0.ɵɵlistener("click", function OrganizeDocumentsLibraryComponent_ng_template_11_div_1_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r35); const singleDoc_r24 = ctx.$implicit; const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.viewDocument(singleDoc_r24.fileLocation); });
    i0.ɵɵelementStart(13, "mat-icon", 45);
    i0.ɵɵtext(14, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_div_15_Template, 3, 0, "div", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const singleDoc_r24 = ctx.$implicit;
    const i_r25 = ctx.index;
    const childNode_r22 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r25 > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", childNode_r22.data.fileCategoryCode === "OTHER" ? singleDoc_r24.fileCtaegoryOtherName : childNode_r22.data.docName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", childNode_r22.data.isGenerated != null && childNode_r22.data.isGenerated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", childNode_r22.data.isGenerated != null && !childNode_r22.data.isGenerated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", singleDoc_r24.uploadedFileName != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", singleDoc_r24.uploadedFileName == null);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r23.disabledControls);
} }
function OrganizeDocumentsLibraryComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, OrganizeDocumentsLibraryComponent_ng_template_11_div_1_Template, 16, 7, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childNode_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", childNode_r22.data.documents);
} }
class OrganizeDocumentsLibraryComponent extends BaseOrganizeDocumentsLibraryService {
    constructor(toastr, store, apiService, stepStatusUpdatePayloadCostruction, appServicesLibraryService) {
        super(toastr, store, apiService, stepStatusUpdatePayloadCostruction, appServicesLibraryService);
        this.toastr = toastr;
        this.store = store;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.organizeDocumentsForm = this.organizeDocumentsForm;
        super.afterViewInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
OrganizeDocumentsLibraryComponent.ɵfac = function OrganizeDocumentsLibraryComponent_Factory(t) { return new (t || OrganizeDocumentsLibraryComponent)(i0.ɵɵdirectiveInject(i1.ToastrService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.APIOrganizeDocuments), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
OrganizeDocumentsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: OrganizeDocumentsLibraryComponent, selectors: [["organize-documents-library"]], viewQuery: function OrganizeDocumentsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.organizeDocumentsForm = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 7, consts: [["organizeDocumentsForm", "ngForm"], [1, "row"], [1, "col-md-10", "d-flex", "align-items-center"], [1, "heading"], [1, "col-md-2"], ["pButton", "", "type", "button", "label", "Reset", 1, "p-button-outlined", 3, "disabled", "click"], [1, "pl-3"], ["draggableScope", "self", "droppableScope", "self", 3, "value", "draggableNodes", "droppableNodes", "validateDrop", "onNodeDrop"], ["pTemplate", "parent"], ["pTemplate", "child"], ["type", "button", "pButton", "", "label", "Save", 3, "disabled", "ngClass", "click"], ["header", "Delete"], [1, "row", "mt-3", "mb-2"], [1, "col-10", "pl-0"], ["closable", "closable", "class", "titleSheet", 3, "style", 4, "ngIf"], ["class", "col-2", "style", "cursor: pointer;", "pTooltip", "Drag & Drop", 4, "ngIf"], [1, "p-datatable", "p-datatable-header", "border", "mt-3", "ml-n4", 2, "width", "100.9%"], [1, "p-datatable-thead"], [2, "min-width", "100%", "display", "inline-table"], [2, "width", "40%"], [1, "ml-3"], ["class", "p-datatable-tbody", 4, "ngIf"], ["closable", "closable", 1, "titleSheet"], ["inplace", ""], ["pTemplate", "display"], [1, "d-inline"], ["inplaceCustom", ""], ["pTemplate", "content"], ["type", "text", "pInputText", "", 3, "ngModel", "ngModelChange"], ["pButton", "", "type", "button", "label", "Save", 1, "ml-2", "button-success", 3, "click"], ["pTooltip", "Drag & Drop", 1, "col-2", 2, "cursor", "pointer"], ["class", "text-right", 4, "ngIf"], [1, "text-right"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary", "ml-0", "mr-4"], [1, "p-datatable-tbody"], [1, "text-secondary"], [1, "p-datatable"], ["class", "p-datatable-tbody", 4, "ngFor", "ngForOf"], ["class", "border", 4, "ngIf"], [1, "d-flex", "align-items-center"], ["style", "font-style: italic; font-size: 11px; color: #cecece;", 4, "ngIf"], [4, "ngIf"], [1, "align-top"], ["pButton", "", "type", "button", "pTooltip", "View", 1, "p-0", "p-button-icon-only", "bg-white", "border-0", "text-secondary", "d-inline", 3, "click"], ["matTooltip", "View", 1, "mr-1", "icn"], ["class", "d-inline pl-1", "style", "cursor: pointer;", "pTooltip", "Drag & Drop", 4, "ngIf"], [1, "border"], [2, "font-style", "italic", "font-size", "11px", "color", "#cecece"], ["pTooltip", "Drag & Drop", 1, "d-inline", "pl-1", 2, "cursor", "pointer"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary", "ml-0", "mr-2"]], template: function OrganizeDocumentsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "h6", 3);
        i0.ɵɵtext(5, "Re-arrange sections & documents");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "button", 5);
        i0.ɵɵlistener("click", function OrganizeDocumentsLibraryComponent_Template_button_click_7_listener() { return ctx.resetOrganizedDocument(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "p-tree", 7);
        i0.ɵɵlistener("onNodeDrop", function OrganizeDocumentsLibraryComponent_Template_p_tree_onNodeDrop_9_listener($event) { return ctx.onDrop($event); });
        i0.ɵɵtemplate(10, OrganizeDocumentsLibraryComponent_ng_template_10_Template, 16, 4, "ng-template", 8);
        i0.ɵɵtemplate(11, OrganizeDocumentsLibraryComponent_ng_template_11_Template, 2, 1, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "hr");
        i0.ɵɵelementStart(13, "button", 10);
        i0.ɵɵlistener("click", function OrganizeDocumentsLibraryComponent_Template_button_click_13_listener() { return ctx.postOrganizedDocument(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "p-confirmDialog", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.supportingDocumentsTree)("draggableNodes", true)("droppableNodes", true)("validateDrop", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("ngClass", ctx.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled btn-primary" : "btn-success button-width-icon-left btn-primary mr-3 pl-4 pr-4");
    } }, directives: [i6.ɵangular_packages_forms_forms_ba, i6.NgControlStatusGroup, i6.NgForm, i7.ButtonDirective, i8.Tree, i9.PrimeTemplate, i10.NgClass, i11.ConfirmDialog, i10.NgIf, i12.Inplace, i6.DefaultValueAccessor, i13.InputText, i6.NgControlStatus, i6.NgModel, i14.Tooltip, i10.NgForOf, i15.MatIcon], styles: [".p-datatable[_ngcontent-%COMP%]{border-bottom:2px solid #dee2e6}.p-datatable[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.p-datatable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .p-datatable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:15px!important;color:#4a4a4a}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;font-size:14px}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#4a4a4a}.title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#626262;margin-bottom:0}.title[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:500}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganizeDocumentsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'organize-documents-library',
                templateUrl: 'organize-documents-library.component.html',
                styleUrls: ['organize-documents-library.component.scss']
            }]
    }], function () { return [{ type: i1.ToastrService }, { type: i2.Store }, { type: i3.APIOrganizeDocuments }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], organizeDocumentsForm: [{
            type: ViewChild,
            args: ['organizeDocumentsForm', { static: true }]
        }] }); })();

class OrganizeDocumentsLibraryModule {
    static forRoot(environment) {
        return {
            ngModule: OrganizeDocumentsLibraryModule,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                }
            ]
        };
    }
}
OrganizeDocumentsLibraryModule.ɵfac = function OrganizeDocumentsLibraryModule_Factory(t) { return new (t || OrganizeDocumentsLibraryModule)(); };
OrganizeDocumentsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: OrganizeDocumentsLibraryModule });
OrganizeDocumentsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseOrganizeDocumentsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(OrganizeDocumentsLibraryModule, { declarations: [OrganizeDocumentsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule], exports: [OrganizeDocumentsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganizeDocumentsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [OrganizeDocumentsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule
                ],
                providers: [BaseOrganizeDocumentsLibraryService],
                exports: [OrganizeDocumentsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of organize-documents-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OrganizeDocumentsLibraryComponent, OrganizeDocumentsLibraryModule, OrganizeDocumentsLibraryService };
//# sourceMappingURL=organize-documents-library.js.map
